import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'deviceStatus'
})
export class DeviceStatusPipe implements PipeTransform {

  transform(eventStatus: number): string {

    switch (eventStatus) {
      case 1:
      return "Offline"

      case 2:
      return "Online"

      default:
      return "Unknown"

        break;
    }

  }

}
